import ReportViewerMenu from './ReportViewerMenu';
export default ReportViewerMenu;
